import React from 'react'
import styles from './Badge.scss'
import cx from 'classnames'

export const Badge = ({ children, type }) => (
  <span className={cx(styles.Badge, styles[type] || styles.default)}>
    {children}
  </span>
)
